"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tappedRegisterToBid = void 0;

var _Schema = require("../../Schema");

/**
 * A user taps on register to bid button within the iOS app
 *
 * @example
 * ```
 * tappedRegisterToBid({
 *   contextModule: true,
 *   contextScreenOwnerId: "5359794d2a1e86c3741001f8",
 *   contextScreenOwnerSlug "auction-slug":
 *   contextScreenOwnerType: "sale",
 * })
 * ```
 */
const tappedRegisterToBid = ({
  contextModule,
  contextScreenOwnerType,
  contextScreenOwnerId,
  contextScreenOwnerSlug
}) => {
  return {
    action: _Schema.ActionType.tappedRegisterToBid,
    context_module: contextModule,
    context_screen_owner_id: contextScreenOwnerId,
    context_screen_owner_slug: contextScreenOwnerSlug,
    context_screen_owner_type: contextScreenOwnerType
  };
};

exports.tappedRegisterToBid = tappedRegisterToBid;